import React from "react";
import Image from "next/image";

export const BRAND_NAME = "Оргил карго";

// Брэндийн тэмдэг + нэр (Header, Footer). Тэмдэг нь түр лого (public/orgilIcon.svg) —
// жинхэнэ логогоор солихдоо энэ файл болон public/orgilIcon.* -г л өөрчилнө.
// tone="light" — бараан дэвсгэр (footer) дээр цагаан бичигтэй.
const BrandLogo = ({ size = 42, tone = "dark" }) => (
  <span className="flex items-center gap-2.5">
    <Image src="/orgilIcon.svg" alt={BRAND_NAME} width={size} height={size} unoptimized className="rounded-xl" />
    <span className="leading-none">
      <span className={`block font-display font-extrabold text-xl tracking-tight ${tone === "light" ? "text-white" : "text-brand-blue"}`}>
        Оргил
      </span>
      <span className="block text-[11px] font-bold uppercase tracking-[0.22em] text-primary">Карго</span>
    </span>
  </span>
);

export default BrandLogo;
